import * as ApiBase from '../../APIBase'
import { getCookieToken, setCookieToken } from '../../utils/cookieToken'
import * as GA from '../../Analytics/googleAnalytics'

import {
  setAccessToken,
  setUserLogin,
  setUserName,
  showCustomerLoginFormValidationMessage,
  showInstructionsSentMessage,
  setUserDefaultEmail,
} from './index'

export const customerLogin = (routeHistory) => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const token = getState().user.accessToken || getCookieToken()

  let json = {}

  const URL = `/${subPath}/customer/login`
  const { isFormValid, email, password } = getState().loginForm

  if (isFormValid) {
    json = await ApiBase.post(URL, {
      email: email.value,
      password: password.value,
    }, token)
  }

  if (json.success) {
    dispatch(setAccessToken(json.access_token))
    setCookieToken(json.access_token)
    dispatch(setUserLogin(json.success))
    dispatch(setUserName(json.first_name))
    routeHistory.replace('/orders')
    // dispatch(customerAccountLogin(json))
  }

  dispatch(showCustomerLoginFormValidationMessage(json.success, json.message))

  return json
}

export const customerRegister = (routeHistory, params) => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name
  const token = getState().user.accessToken

  let json = {}

  const URL = `/${merchantCanonicalName}/customer/register`

  json = await ApiBase.post(URL, {
    ...params,
  }, token)

  if (json.success) {
    dispatch(setAccessToken(json.access_token))
    setCookieToken(json.access_token)
    dispatch(setUserLogin(json.success))
    dispatch(setUserName(json.first_name))
    GA.fireEvent({
      category: 'Bifrost',
      action: 'Signup',
      label: merchantCanonicalName,
    })
    routeHistory.replace('/orders')
  }

  dispatch(showCustomerLoginFormValidationMessage(json.success, json.message))

  return json
}

export const customerLogout = () => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const token = getState().user.accessToken
  const URL = `/${subPath}/customer/logout`

  const json = await ApiBase.post(URL, {}, token)

  if (json) {
    window.location.replace(window.location.origin)
  }
}

export const sendMeResetPasswordInstructions = (captcha) => async (dispatch, getState) => {
  const { email } = getState().forgotPassword
  const subPath = getState().merchant.canonical_name
  const token = getState().user.accessToken

  const URL = `/${subPath}/customer/password_reset_instructions`

  let message = ''
  let json = {}
  if (email.isValid) {
    json = await ApiBase.post(URL, {
      email: email.value,
      captcha,
    }, token)

    if (json.success) {
      message = 'Instructions sent! Please check your email inbox for a link to reset your password.'
    } else {
      message = 'Sorry, we weren\'t able to find any users with that email address.'
    }

    dispatch(showInstructionsSentMessage(json.success, message))
  }
}

export const getUsersDefaultEmail = () => async (dispatch, getState) => {
  const { email } = getState().profile.info
  if (email) {
    dispatch(setUserDefaultEmail(email))
  } else {
    const subPath = getState().merchant.canonical_name
    const token = getState().user.accessToken
    const URL = `/${subPath}/customer/profile`
    const json = await ApiBase.get(URL, {}, token)
    if (json.success) {
      dispatch(setUserDefaultEmail(json.profile_info.email))
    }
  }
}
